import { render } from "./MainComponent.vue?vue&type=template&id=c4c4dc7a"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sweaton/WebstormProjects/paygateway/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__